import React from 'react';

const Suggestion = ({
  place,
  clickHandler,
  cursorIdx,
  idx,
  selectColor,
  mouseInSuggestions,
  isTouch
}) => {
  const isActive = cursorIdx === idx && !mouseInSuggestions && !isTouch;

  return (
    <div
      className="suggestionWrapper"
      style={{
        backgroundColor: isActive ? selectColor : 'transparent',
        color: isActive ? 'white' : 'inherit'
      }}
      onMouseDown={event => clickHandler({ location: place, event })}
    >
      {place.formattedAddress}
    </div>
  );
};

export default Suggestion;
